import { render, staticRenderFns } from "./SelecaoModulo.vue?vue&type=template&id=169fb63a&scoped=true&"
import script from "./SelecaoModulo.vue?vue&type=script&lang=js&"
export * from "./SelecaoModulo.vue?vue&type=script&lang=js&"
import style0 from "./SelecaoModulo.vue?vue&type=style&index=0&id=169fb63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169fb63a",
  null
  
)

export default component.exports